import { render, staticRenderFns } from "./tableShift.vue?vue&type=template&id=5712b660&scoped=true"
import script from "./tableShift.vue?vue&type=script&lang=js"
export * from "./tableShift.vue?vue&type=script&lang=js"
import style0 from "./tableShift.vue?vue&type=style&index=0&id=5712b660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712b660",
  null
  
)

export default component.exports